import { Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { Image, ImageURISource, SafeAreaView, StyleSheet } from 'react-native'
import { useSelector } from 'react-redux'
import emailValidated from '../../assets/images/email_validated.png'
import { Button } from '../../components/Button'
import { i18n } from '../../lib/i18n'
import { menuSelector } from '../../redux/menu/selector'
import { popToTop } from '../../services/navigation'
import { theme } from '../../theme'

const LOGO_HEIGHT = 76
const IMAGE_HEIGHT = 200

const styles = StyleSheet.create({
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: theme.padding.x3,
  },
  title: {
    fontSize: 30,
    lineHeight: 30,
    color: theme.colors.black,
    marginBottom: theme.padding.x3,
  },
  subtitle: {
    color: theme.colors.silverStrong,
    marginBottom: theme.padding.x4,
  },
  logo: {
    height: LOGO_HEIGHT,
    width: '100%',
    marginBottom: theme.padding.x2,
  },
  image: {
    height: IMAGE_HEIGHT,
    width: '100%',
    marginBottom: theme.padding.x4,
    marginVertical: theme.padding.x4,
  },
})

export const EmailVerificationDone: FunctionComponent = () => {
  const menu = useSelector(menuSelector)

  const logoUri = menu && menu.header && menu.header.image

  return (
    <View>
      <SafeAreaView style={styles.content}>
        {!!logoUri && <Image style={styles.logo} source={{ uri: logoUri }} resizeMode="contain" />}
        <Text style={styles.title}>{i18n.t('emailVerificationDone.title')}</Text>
        <Text style={styles.subtitle}>{i18n.t('emailVerificationDone.subtitle')}</Text>
        <Image style={styles.image} source={emailValidated as ImageURISource} resizeMode="contain" />
        <Button style={{ marginTop: theme.padding.x3, backgroundColor: theme.colors.green }} onPress={() => popToTop()} label={i18n.t('emailVerificationDone.continue')} />
      </SafeAreaView>
    </View>
  )
}
